// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__FCy6P","paramInput":"JobSimulator_paramInput__3VUaa","input":"JobSimulator_input__1PloP"};